// Budget for the widest ordinary volume label (000.00M) at the workspace's
// 11px font, including native axis padding. Larger price magnitudes get a
// whole-digit allowance, so changing narrow/wide digits cannot resize it.
export const COMPACT_PRICE_SCALE_MINIMUM_WIDTH = 68

export function stablePriceScaleWidth(bars = [], minimumWidth = COMPACT_PRICE_SCALE_MINIMUM_WIDTH) {
  let largest = 0
  for (const bar of bars || []) {
    for (const key of ['open', 'high', 'low', 'close']) {
      const value = bar?.[key]
      if (typeof value === 'number' && Number.isFinite(value)) {
        largest = Math.max(largest, Math.abs(value))
      }
    }
  }
  const digits = largest >= 1 ? Math.floor(Math.log10(largest)) + 1 : 1
  return minimumWidth + Math.max(0, digits - 4) * 8
}
